import { useState } from "react";
import { useLocale, COUNTRIES } from "../../../context/locale";
import { ChevronDown } from "lucide-react";

const CountrySelector = () => {
  const { country, setCountry } = useLocale();
  const [open, setOpen] = useState(false);
  const current = COUNTRIES[country];

  return (
    <div className="relative">
      <button
        type="button"
        className="nav-link flex items-center gap-1"
        onClick={() => setOpen((o) => !o)}
        aria-label={`Change country (currently ${current.label})`}
      >
        <span style={{ fontSize: "20px", lineHeight: 1 }}>{current.flag}</span>
        <ChevronDown size={13} />
      </button>

      {open && (
        <div className="absolute top-full right-0 pt-3 w-56 z-50">
          <div className="card-ledger p-2 flex flex-col gap-1 shadow-lg text-left">
            {Object.entries(COUNTRIES).map(([code, c]) => (
              <button
                key={code}
                type="button"
                disabled={!c.available}
                onClick={() => {
                  setCountry(code);
                  setOpen(false);
                }}
                className="flex items-center justify-between gap-3 px-3 py-2 rounded text-sm normal-case tracking-normal font-body"
                style={{ opacity: c.available ? 1 : 0.45, cursor: c.available ? "pointer" : "not-allowed" }}
              >
                <span className="flex items-center gap-2">
                  <span style={{ fontSize: "20px", lineHeight: 1 }}>{c.flag}</span>
                  <span>{c.label}</span>
                </span>
                {!c.available && <span className="tag-coming-soon" style={{ fontSize: "9px", padding: "1px 6px" }}>Soon</span>}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountrySelector;
